import { useCallback } from 'react';
import type { ExtendedInvitationsFormValues } from '../../../../../../invitations-form-content';
import type { EventCreateParticipant } from '../../../../../../types';

type DistributionListItem = {
  communityId: string;
  communityName: string;
};

type InvitationsRequestData = {
  distributionList: DistributionListItem[];
  participants: EventCreateParticipant[];
};

export const useGetInvitationsRequestData = () =>
  useCallback((formValues: ExtendedInvitationsFormValues): InvitationsRequestData => {
    const invitations = formValues.invitations ?? [];

    return {
      distributionList: invitations
        .filter((invitation) => invitation.type === 'community')
        .map((invitation) => ({
          communityId: invitation.value,
          communityName: invitation.label,
        })),
      participants: invitations
        .filter((invitation) => invitation.type !== 'community')
        .map((invitation) =>
          invitation.type === 'email'
            ? { email: invitation.value, role: invitation.role, type: 'email' }
            : { ref: invitation.value, role: invitation.role, type: 'user' },
        ),
    };
  }, []);
